<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :toptype="toptype" :isSearch="path"></topnav>
        <div class="" style="min-height: 600px">
            <div class="" v-if="config">
                <el-image class="topimg" :src="config.rzqy_pic | addurl" fit="fill"></el-image>
            </div>
            <div class="response bggray">
                <div class="marginauto comswidth">
                    <div class="bg-white topall flex justify-between align-center">
                        <div class="flex justify-start align-center imgall">
                            <el-image class="topsimg" src="/static/assets/images/com.png" fit="fill"></el-image>
                        </div>
                        <div class="flex-sub pointer">
                            <div class="toptitle" style="margin-bottom: 0;">企业入驻申请</div>
                            <!-- <div class="topinfo">目前已有<span class="textcolor"> {{config ? config.shop_number : '0'}} </span>企业入驻平台</div> -->
                        </div>
                        <div class="" style="width: 330px;">
                            <div @click="tonext" class="topbtn pointer">立即申请</div>
                        </div>
                    </div>
                    <div class="margin-top flex animated slideInLeft flex-wrap align-center justify-start">
                        <div v-for="(item,index) in list" :key="index" class="bg-white marone hvr-float martwo">
                            <div class="flex">
                                <div class="flex align-center" style="width: 90px;height: 90px;">
                                    <el-image style="width: 90px;height: 90px;" :src="item.shop_logo | addurl" fit="cover"></el-image>
                                </div>
                                <div class="" style="padding-left: 15px;height: 90px;padding-top: 10px;width: 70%;">
                                    <div class="text-cut" style="color: #262626;font-size: 21px;margin-bottom: 15px;">{{item.shop_name}}</div>
                                    <div class="text-cut response" style="color: #9c9c9c;font-size: 20px;">{{item.add_detail}}</div>
                                </div>
                            </div>
                            <div class="flex justify-between align-center margin-top">
                                <div class="" style="color: #1b1b1b;font-size: 18px;">
                                    浏览 <span style="color: #ff9703;">{{item.see_number}}</span>
                                </div>
                                <div @click="todetail(item.id)" class="dbtn pointer">
                                    详情
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="text-center response" style="">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :pager-count="pagerCount"
                            :hide-on-single-page="true"
                            :page-size="pagesize"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalnum"
                            >
                        </el-pagination>
                    </div> -->
                    <div v-if="list.length" class="flex justify-center " style="margin-top: 30px;">
                        <div @click="tolist" class="topbtn pointer">查看更多</div>
                    </div>
                    <div v-if="!list.length">
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["userinfo","token"])
    },
    data() {
        return{
            load: true,
            toptype: 8,
            pagesize: 10,
            totalnum: 100,
            currentPage: 1,
            pagerCount: 7,
            list: [],
            info:'',
            config: '',
            path: '/company',
            keyword: '',
            type: ''
        }
    },
    methods:{
        tolist(){
             this.$router.push({path: '/company_list'})
        },
        todetail(id){
            this.$router.push({path: '/comdetail',query: {
                id: id
            }})
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
        },
        tonext(){
            console.log(';;;;;',this.token)
            if(!this.token){
                this.$message.error('请登录！')
                return false;
            }
            if(this.type == 1){
                this.$message.error('请切换为个人登录！')
                return false;
            }else if(this.type == 2){
                if(this.info.shop){
                    if(this.info.shop.status == 0){
                        this.$message('申请已提交，正在审核中');
                        return false;
                    }else if(this.info.shop.status == 2){
                        this.$alert(this.info.shop.remark, '您的申请被拒绝,请重新申请', {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$router.push({path: '/companyinfo',query: {id: this.info.shop.id}})
                            }
                        });
                        return false;
                    }else if(this.info.shop.status == 1){
                        this.$message('您已成功入驻！');
                        return false;
                    }
                }
            }
            this.$router.push({path: '/companyinfo'})
        },
        getstartlist(){
            
            this.$api.index.shop_rand().then(response => {
                this.list = response.data;
            })
        },
        getuserinfo(){
            var type = localStorage.getItem('type');
            if(type == 2){
                var types = 1;
            }else if(type == 1){
                var types = 2;
            }
            var data = {
                type: types,
                user_id: this.token
            }
            this.$api.user.userinfo(data).then(res=>{
                var data = res.data;
                this.info = data;
                var sdata = JSON.stringify(data)
                // this.$store.commit('SET_USERINFO',sdata)
                localStorage.setItem('userinfo', sdata)
            })
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getstartlist();
        },
    },
    created(){
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getstartlist();
        }else{
            this.getstartlist();
        }
        if(localStorage.getItem('token')){
            this.getuserinfo();
        }
        this.type = localStorage.getItem('type')
        this.config = JSON.parse(localStorage.getItem('config'))
    }
}
</script>
<style scoped>
    .comswidth{
        width: 1320px;position: relative;top: -75px;
    }
    .topimg{
        width: 100%;height: 500px;display: block;
    }
    .bggray{
        background-color: #eef1fa;
    }
    .topall{
        width: 1220px;
        height: 100px;
        background-color: #ffffff;
        box-shadow: 0px 5px 20px 1px rgba(160, 160, 160, 0.21);
        border-radius: 4px;
        padding: 40px 50px;

    }
    .margin-top{
        margin-top: 30px;
    }
    .topsimg{
        width: 100px;height: 100px;
    }
    .topbtn{
        width: 330px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        color: #fff;
        background-color: #1759d8;
        border-radius: 10px;
        font-size: 24px;
    }
    .imgall{
        width: 130px;
    }
    .toptitle{
        color: #161616;font-size: 28px;font-weight: 600;margin-bottom: 35px;
    }
    .topinfo{
        color: #9a9a9a;font-size: 24px;
    }
    .textcolor{
        color: #1759d8;
    }
    .dbtn{
        width: 120px;
        line-height: 35px;
        height: 35px;
        text-align: center;
        background-color: #ffab18;
        border-radius: 4px;
        color: #fff;
        font-size: 18px;
    }
    .marone{
        margin-bottom: 15px;
        padding: 25px 25px 25px 20px;border-radius: 4px;width: 385px;
    }
    .martwo{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// company.vue?b3ca2358